export default __webpack_public_path__ + "images/63ce4818c336d8e698778019f573bee3-comedy_desktop.webp";